export const textValidationPattern = /^[a-zA-Z0-9\sÅåÄäÖö]*$/;
export const numberValidationPattern = /^[0-9]*$/;
export const emailValidationPattern = /^[a-zA-Z0-9.\-_]+@[a-zA-Z0-9.\-_]+\.[a-zA-Z0-9]+$/;
export const emailWithEmptyStringValidationPattern = /^$|[a-zA-Z0-9.\-_]+@[a-zA-Z0-9.\-_]+\.[a-zA-Z0-9]+$/;
export const domainCodeStringValidationPattern = /^[^;:'"()#]*$/;
